<template lang="pug">
.options
  .backdrop
  .content
    .close(@click="cancel") ×
    .title {{this.overlaydata.title}}
    .description {{this.overlaydata.description}}
    .form
      .field(v-if="this.overlaydata.prooftype !== 'disability'")
        label(for="field-documentvalidity")
          NewTranslation(path="ticketBooking.overlays.proofUpload.date.label")
          | *
        .field-input
          font-awesome-icon(icon="calendar")
          input(id="field-documentvalidity" type="date" required)
      .field
        label(for="field-documentupload")
          | Dokumentenvorderseite
        .field-input
          font-awesome-icon(icon="file")
          input(id="field-documentupload" type="file" accept="image/*,.pdf")
      .field
        label(for="field-documentupload-2")
          | Dokumentenrückseite
        .field-input
          font-awesome-icon(icon="file")
          input(id="field-documentupload-2" type="file" accept="image/*,.pdf")
      .field(v-if="this.overlaydata.prooftype === 'disability'")
        label(for="field-disabilitydegree") Behinderungsgrad
        .field-input
          font-awesome-icon(icon="wheelchair")
          input(id="field-disabilitydegree" type="number" min="20" max="100" step="10" v-model="disabilityDegree")
      .field(v-if="this.overlaydata.prooftype === 'disability'")
        label Merkzeichen
        .field-input.disability-markers
          Button(:block="false" :small="true" color="gray" v-for="marker in availableDisabilityMarkers" :key='marker' @click.native="toggleMarker(marker)" :class="{'disability-marker-active': isMarkerActive(marker)}").disability-marker {{marker}}
        .field-input(v-if="disabilityMarkers.length > 0")
          | Gewählte Merkzeichen: {{disabilityMarkers.join(', ')}}
      Button(color="green" @click.native="success").button
        NewTranslation(path="ticketBooking.overlays.proofUpload.btn.continue")
        font-awesome-icon(icon="chevron-right" slot="icon" style="padding-left: 2px")
</template>

<script>
import Button from '@/components/Button.vue';
import NewTranslation from '@/components/i18n/NewTranslation';

export default {
  components: {
    NewTranslation,
    Button,
  },
  props: ['overlaydata'],
  data() {
    return {
      disabilityDegree: 20,
      availableDisabilityMarkers: ['G', 'B', 'aG', 'Gl', 'H', 'Bl', 'TBl'],
      disabilityMarkers: [],
    };
  },
  methods: {
    cancel() {
      if (this.overlaydata && this.overlaydata.cancel) this.overlaydata.cancel();
      this.$store.commit('openOverlay', '');
    },
    success() {
      if (this.overlaydata && this.overlaydata.success)
        this.overlaydata.success({
          disabilityDegree: this.disabilityDegree,
          disabilityCertificateId: this.disabilityCertificateId,
        });
      this.$store.commit('openOverlay', '');
    },
    toggleMarker(marker) {
      const markerIndex = this.disabilityMarkers.indexOf(marker);
      if (markerIndex === -1) {
        this.disabilityMarkers.push(marker);
      } else {
        this.disabilityMarkers.splice(markerIndex, 1);
      }
    },
    isMarkerActive(marker) {
      return this.disabilityMarkers.indexOf(marker) > -1;
    },
  },
};
</script>

<style lang="sass" scoped>
.options
  width: 100%
  height: 100vh
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  position: fixed
  max-width: 480px
  margin: 0 auto
  right: 0
  top: 0
  left: 0
  z-index: 9

.backdrop
  background-color: rgba(0, 0, 0, .8)
  width: 100%
  height: 100vh
  position: absolute
  z-index: 6

.close
  position: absolute
  right: 20px
  top: 20px
  background-color: #fff
  z-index: 9
  color: #1DB2D1
  border: 1px solid #1DB2D1
  width: 20px
  height: 20px
  display: flex
  justify-content: center
  align-items: center
  border-radius: 20px

.content
  z-index: 7
  background-color: #fff
  border-radius: 10px
  padding: 20px
  margin: 20px
  position: relative
  max-height: 100vh
  overflow: scroll

.title
  font-size: 20px
  color: #1DB2D1
  text-align: center

.description
  text-align: center
  color: #454F63
  margin-top: 20px

.form
  margin-top: 20px

  .field
    display: flex
    flex-direction: column

    & + .field
      margin-top: 20px

    input,
    select
      color: #454F63
      border-radius: 3px
      border: 1px solid #B3BAC8
      padding: 15px 15px 15px 45px
      margin-top: 5px
      background-color: #fff
      font-size: 1rem
      font-family: inherit
      width: 100%

    &-input
      position: relative

      svg
        position: absolute
        bottom: 0
        top: 5px
        left: 20px
        width: 15px
        margin-top: auto
        margin-bottom: auto

      input[type="date"]
        min-height: 50px
        -webkit-appearance: textfield
        appearance: textfield
        width: 100%

  .button
    margin-top: 20px

.disability-markers
  margin: 4px -4px

.disability-marker
  margin: 4px

.disability-marker-active
  background-color: #2d3038 !important
</style>
